import { atom, useRecoilState } from 'recoil'

const NAMESPACE = 'streamcast-'

const sortOrderState = atom({
  key: `${NAMESPACE}sortOrderState-${Math.random()}`,
  default: {
    by: 'site_name',
    direction: 'desc',
  },
})

export const useSortOrder = () => {
  return useRecoilState(sortOrderState)
}

const filter = atom({
  key: `${NAMESPACE}filterStreamCastState`,
  default: {
    verbatim: '',
    deviceTypes: [],
    statuses: []
  },
})

export const useFilter = () => {
  return useRecoilState(filter)
}

const messagesState = atom({
  key: `${NAMESPACE}messagesState`,
  default: [],
})

export const useMessages = () => {
  return useRecoilState(messagesState)
}
